import { VARIANT_COLOR_ENUM } from '@/types/utils';

export const STATUS_TO_CHIP = {
  DRAFT: VARIANT_COLOR_ENUM.DISABLED,
  COMPLETE: VARIANT_COLOR_ENUM.ERROR,
  FINISHED: VARIANT_COLOR_ENUM.SUCCESS,
  CANCELED: VARIANT_COLOR_ENUM.ERROR,
  PUBLISHED: VARIANT_COLOR_ENUM.ERROR,
};
